export default String.raw`
<div class="page-padding">
    {% if config.DefinedPages.Registration.Id == page.PageId -%}
    {% endif -%}
    <div class="reg-container container-js">
        {% if config.CompanyOnly == false and settings.defaultRegistration == 'retail' -%}
            {% if config.Registration.Retail.AddressVisible -%}
                {% include 'static-elements/register-with-address/register-with-address.html' with 'retail' -%}
            {% else -%}
                {% include 'static-elements/register-no-address/register-no-address.html' with 'retail' -%}
            {% endif -%}
        {% else -%}
            {% if config.Registration.Company.AddressVisible -%}
                {% include 'static-elements/register-with-address/register-with-address.html' with 'company' -%}
            {% else -%}
                {% include 'static-elements/register-no-address/register-no-address.html' with 'company' -%}
            {% endif -%}
        {% endif -%}
    </div>
</div>
`